import { createGlobalStyle } from 'styled-components';
import { Fonts } from '../constants/fonts';
import { FontFace } from './fontFace';
import { Colors } from '../constants/colors';
import { Device } from '../constants/device';

const GlobalStyle = createGlobalStyle`
  ${FontFace}
  body {
    margin: 0;
    padding: 0;
    background: ${Colors.background};
    font-family: ${Fonts.base};

    * {
      box-sizing: border-box;
    }
  }

  h1, h2, h3, h4, h5 {
    font-family: ${Fonts.secondary};
  }

  html, body, #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  h1 {
    ${Device.downTablet} {
      font-size: 28px;
    }
  }
`;

export default GlobalStyle;
